import { render, staticRenderFns } from "./ProjectIntroduction.vue?vue&type=template&id=104c768b&scoped=true"
import script from "./ProjectIntroduction.vue?vue&type=script&lang=js"
export * from "./ProjectIntroduction.vue?vue&type=script&lang=js"
import style0 from "./ProjectIntroduction.vue?vue&type=style&index=0&id=104c768b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c768b",
  null
  
)

export default component.exports